import "./introduction.css";
import resume from "../assets/resume.pdf";

import Fade from "react-reveal/Fade";

const Introduction = () => {
  return (
    <div id="introduction" className="introduction-container">
      <h5 className="h5 heading-5"> Hi, My name is </h5>
      <Fade bottom>
        <h1 className=" heading-1">Zabihullah Azadzoi</h1>
        <h2 className="heading-2">I build things for the web.</h2>
        <p className="introduction-container_paragraph">
          I'm a software developer with rock-solid experience in building
          complex applications with modern technologies.
        </p>
      </Fade>

      <button className="portfolio-button">
        {" "}
        <a
          className="color-primary text-decoration-none"
          href={resume}
          target="_blank"
          rel="noreferrer"
        >
          Check out my Resume
        </a>
      </button>
    </div>
  );
};

export default Introduction;
